var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col pt-8 gap-8 h-auto px-8" }, [
    _c("div", { staticClass: "gap-4 flex flex-col" }, [
      _c("p", { staticClass: "font-normal text-lg" }, [_vm._v("Description")]),
      _vm.description
        ? _c(
            "p",
            {
              staticClass: "text-storm-gray text-base customLineH break-words",
            },
            [_vm._v(_vm._s(_vm.description))]
          )
        : _c("p", { staticClass: "text-storm-gray text-base customLineH" }, [
            _vm._v("No description added."),
          ]),
    ]),
    _c(
      "div",
      { staticClass: "gap-4 flex flex-col" },
      [
        _c("p", { staticClass: "font-normal text-lg" }, [_vm._v("Status")]),
        !_vm.status
          ? _c("Badge", {
              class: _vm.badgeData.class,
              attrs: { color: _vm.badgeData.color, value: _vm.badgeData.value },
            })
          : _c("Badge", {
              class: _vm.badgeData.class,
              attrs: { color: _vm.badgeData.color, value: _vm.badgeData.value },
            }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex flex-col gap-3" },
      [
        _c("p", { staticClass: "font-normal text-lg" }, [
          _vm._v("Skills "),
          _vm.getSkils.length > 0
            ? _c("span", { staticClass: "totalNumber ml-0.5" }, [
                _vm._v("(" + _vm._s(_vm.getSkils.length) + ")"),
              ])
            : _vm._e(),
        ]),
        _vm.getSkils.length
          ? _c("ItemChipsWithMore", {
              attrs: {
                showAll: true,
                items: _vm.getSkils,
                fullItem: true,
                title: "",
                limit: 100,
              },
            })
          : _c("p", { staticClass: "text-storm-gray text-base customLineH" }, [
              _vm._v("No skills added."),
            ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex flex-col gap-3" },
      [
        _c("p", { staticClass: "font-normal text-lg" }, [
          _vm._v("Tags "),
          _vm.getIndustries.length > 0
            ? _c("span", { staticClass: "totalNumber ml-0.5" }, [
                _vm._v("(" + _vm._s(_vm.getIndustries.length) + ")"),
              ])
            : _vm._e(),
        ]),
        _vm.getIndustries.length
          ? _c("ItemChipsWithMore", {
              attrs: {
                showAll: true,
                items: _vm.getIndustries,
                fullItem: true,
                title: "",
                limit: 100,
              },
            })
          : _c("p", { staticClass: "text-storm-gray text-base customLineH" }, [
              _vm._v("No tags added."),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }